import lightOrDarkColor from '@check-light-or-dark/color';


export default function fontColor(color = null){
  if(lightOrDarkColor(color) === 'dark'){
    return '#FFFFFF ';
  }
  else if(color === null) {
    return '#FFFFFF ';
  }
  else {
    return '#000000 ';
  }
}